export const squareMetersPerAcre = 4046.86;

export const squareFeetPerAcre = 43560.0;
